import { defineStyleConfig } from "@chakra-ui/react"

const Select = defineStyleConfig({
  baseStyle: {
    field: {
      borderRadius: '8px',
      _focus: {
        borderColor: 'brand.focusBorder !important',
        boxShadow: '0 0 0 4px var(--chakra-colors-brand-focusShadow) !important'
      },
    }
  },
  defaultProps: {
    size: 'sm',
  }
})

export default Select
